import swalAlert from '../utils/swalAlert'
import { QINIU_CDN } from '../config/index'
let base = {

  computed: {
    isWechat () {
      return /micromessenger/.test(window.navigator.userAgent.toLowerCase())
    },
    isiOS () {
      return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    },
    isBusy: {
      cache: false,
      get () {
        return this.$store.getters.isLoading
      }
    },
    userInfo: {
      cache: false,
      get () {
        return this.$store.getters.getUserInfo
      }
    },
    merchantInfo: {
      cache: false,
      get () {
        return this.$store.getters.getMerchantInfo
      }
    },
    merchantRules: {
      cache: false,
      get () {
        return this.$store.getters.getMerchantRules
      }
    },
    token_: {
      cache: false,
      get () {
        return this.$store.getters.getToken
      }
    },
    sub_qr_code: {
      cache: false,
      get () {
        return this.$store.getters.getMerchantInfo.sub_qr_code
      }
    },
    /** H5 首页轮播：poster_img 支持单 URL 字符串或逗号分隔，统一成数组 */
    posterSlides () {
      const p = this.merchantInfo && this.merchantInfo.poster_img
      if (p == null || p === '') return []
      if (Array.isArray(p)) return p.filter(Boolean)
      return String(p).split(',').map(s => s.trim()).filter(Boolean)
    }
  },

  methods: {
    /**
     * 当前垫付订单 id：路由 query.activityID 即领取接口返回的订单 id。
     * keep-alive / 异步详情下 detail.id 可能仍为上一单，接口传参应优先用路由。
     */
    currentActivityOrderId () {
      const q = this.$route.query.activityID
      if (q !== undefined && q !== null && q !== '') return q
      const d = this.detail
      return d && d.id != null ? d.id : undefined
    },
    // 更新用户信息
    updateUserInfo (callback) {
      let this_ = this
      this.$store.commit('setShowPage', false)
      this.$http.post('mapi/User/getUserData').then(res => {
        this.$store.commit('saveUserInfo', res.data.user_info)
        this.$store.commit('saveMerchantInfo', res.data.merchant_info)
        this.$store.commit('saveMerchantRules', res.data.merchant_rules)
        let getTemplateType = this.$store.getters.getTemplateType

        if (res && res.data && res.data.merchant_rules && res.data.merchant_rules.delivery_model !== undefined) {
          this.$store.commit('setTemplateType', res.data.merchant_rules.delivery_model)
          // this.$store.commit('setTemplateType', 1)
          console.log(getTemplateType, this.$store.getters.getTemplateType)
          // console.log(this.$route)
          // this.$router.go(0)

          if (parseInt(getTemplateType) !== parseInt(res.data.merchant_rules.delivery_model)) {
          // if (parseInt(getTemplateType) !== 1) {
            // console.log('2222')
            // location.reload()
            // this.$router.replace({path: this.$route.path})
            this.$router.go(0)
            // this.$store.commit('setShowPage', true)
          } else {
            this.$store.commit('setShowPage', true)
          }
        }

        let state = res.data.user_info.state

        // 检测是否关闭注册
        if (res.data.merchant_rules.fans_close_register === 1 && (state === 0 || state === 6)) {

        }

        switch (state) {
          case 0: // 待提交
            this.$router.push({ name: 'certification', query: { token: this.token_ } })
            this.$store.commit('setShowPage', true)
            break
          case 1: // 审核通过
            this.$router.push({ name: 'home', query: { token: this.token_ } })
            this.$store.commit('setShowPage', true)
            break
          case 3:// 拉黑

            window.location.replace('http://www.ashhdhdh3333jjdj/')
            // this.$router.push({name: 'blackState'})
            // window.location.replace() = 'http://gdxmwk.cn'
            break
          case 5:// 审核中
          case 6:// 审核被拒绝
            this.$router.push({ name: 'certification', query: { token: this.token_ } })
            this.$store.commit('setShowPage', true)
            break
        }

        // 弹窗提示
        if (res.data.message_popup && res.data.message_popup.length > 0) {
          let messagePop = res.data.message_popup
          messagePop.forEach((i, k) => {
            swalAlert.alertCustom({
              customClass: 'homeRushAlert',
              confirmButtonClass: 'appConfirmButtonClass',
              imageUrl: require('@c_static/img/' + i.pop_logo + ''),
              title: i.type.value_name,
              html: '<div style="margin: 2.3vw 0 1vw; color: #999">' + i.content + '</div>',
              showCloseButton: false
            }).then(function (x) {
              // 提交已读
              this_.$http.post('mapi/User/isRead', { id: i.id })
            })
          })
        }

        if (callback) {
          callback(res.data)
        }
      }).catch(() => {
        this.$store.commit('setShowPage', 1)
      })
    },
    getQiNiuYunToken () {
      this.$http.post('mapi/Upload/getSrytUploadToken').then(res => {
        window.$upToken = res.data.uptoken
        window.$qiniuUrl = res.data.qiniu_url
        // window.$quniuUrl = QINIU_CDN
      })
    },

    /** 放弃活动后回首页：显式带 token，避免 history.back 栈或拦截器读不到 token 触发 9999 跳转微信授权 */
    navigateHomeAfterGiveUp () {
      const tk = this.token_ || window.localStorage.getItem('token')
      if (tk) {
        window.localStorage.setItem('token', tk)
        this.$store.commit('saveToken', tk)
      }
      this.$router.replace({ name: 'home', query: tk ? { token: tk } : {} })
    },

    // 更新地址
    getUserLocation (loadingText = '') {
      let that_ = this
      return new Promise((resolve, reject) => {
        if (loadingText) {
          that_.$store.dispatch('openLoading', loadingText)
        } else {
          that_.$store.dispatch('openLoading')
        }

        // 判断请求是否是https
        try {
          AMap.plugin('AMap.Geolocation', function () {
            var geolocation = new AMap.Geolocation({
              enableHighAccuracy: false, // 是否使用高精度定位，默认:true
              timeout: 10000, // 超过10秒后停止定位，默认：无穷大
              maximumAge: 0, // 定位结果缓存0毫秒，默认：0
              convert: true // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            })
            geolocation.getCurrentPosition()
            AMap.event.addListener(geolocation, 'complete', onComplete_)
            AMap.event.addListener(geolocation, 'error', onError_)
            function onComplete_ (r) {
              // 精度为undefined 代表用户拒绝授权地理位置
              let param = {}
              param.latitude = r.position.lat
              param.longitude = r.position.lng
              param.country = r.addressComponent.country
              param.province = r.addressComponent.province
              param.city = r.addressComponent.city
              param.city_code = r.addressComponent.citycode
              param.district = r.addressComponent.district
              param.town = r.addressComponent.township
              param.street = r.addressComponent.street
              param.street_number = r.addressComponent.streetNumber
              that_.$http.post('mapi/User/updateUserLocation', param).then(res => {
                that_.$store.dispatch('closeLoading')
                that_.$dialog.alert({
                  title: '提示',
                  message: '更新成功！'
                })
                resolve(res)
              })
            }
            function onError_ (data) {
              if (that_.isiOS) {
                that_.getLngLatLocation().then(res => {
                  resolve(res)
                }).catch(() => {
                  reject()
                })
              } else {
                reject()
                that_.$dialog.alert({
                  title: '提示',
                  message: '获取收货省市位置失败，请刷新页面重新尝试点击获取！'
                })
              }
              that_.$store.dispatch('closeLoading')
            }
          })
        } catch (e) {
          reject()
          that_.$store.dispatch('closeLoading')
          alert('页面出错误，请尝试重新打开！')
        }
      })
    },

    getLngLatLocation () {
      let that_ = this
      return new Promise((resolve, reject) => {
        try {
          AMap.plugin('AMap.CitySearch', function () {
            var citySearch = new AMap.CitySearch()
            citySearch.getLocalCity(function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                // 逆向地理编码
                AMap.plugin('AMap.Geocoder', function () {
                  var geocoder = new AMap.Geocoder({
                    // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                    city: result.adcode
                  })
                  var lnglat = result.rectangle.split(';')[0].split(',')
                  geocoder.getAddress(lnglat, function (status, data) {
                    if (status === 'complete' && data.info === 'OK') {
                      // 精度为undefined 代表用户拒绝授权地理位置
                      let param = {}
                      param.latitude = lnglat[1]
                      param.longitude = lnglat[0]
                      param.country = data.regeocode.addressComponent.country
                      param.province = data.regeocode.addressComponent.province
                      param.city = data.regeocode.addressComponent.city
                      param.city_code = data.regeocode.addressComponent.citycode
                      param.district = data.regeocode.addressComponent.district
                      param.town = data.regeocode.addressComponent.township
                      param.street = data.regeocode.addressComponent.street
                      param.street_number = data.regeocode.addressComponent.streetNumber
                      that_.$http.post('mapi/User/updateUserLocation', param).then(res => {
                        that_.$dialog.alert({
                          title: '提示',
                          message: '更新成功！'
                        })
                        that_.$store.dispatch('closeLoading')
                        resolve(res)
                      })
                    } else {
                      reject()
                    }
                  })
                })
              }
            })
          })
        } catch (e) {
          reject()
          that_.$store.dispatch('closeLoading')
        }
      })
    },

    showImg (name) {
      this.$router.push({ name: 'showImg', query: { name: name } })
    },
    showVideo (videoUrl) {
      this.$router.push({ name: 'showVideo', query: { videoUrl: videoUrl } })
    },
    showImgUrl (imgUrl) {
      this.$router.push({ name: 'showImg', query: { imgUrl: imgUrl } })
    }

  }

}
export default base



// WEBPACK FOOTER //
// ./src/mixins/base.js